import repository from "Services/Repository";
import { Result } from "Models/result";
import sessionService from "Store/module/sessionService";
import moment from "moment";

const login = async (userName: String, password: String): Promise<Result<ICertificate>> => {
    const res = await repository.post("/Api/TokenWeb/Login", {
        userName: userName,
        password: password
    });
    const result = repository.getResult<any>(res);
    let data: ICertificate | undefined;
    const expired = moment.utc().add(1, 'days').toDate();
    if (result.Ok()) {
        data = {
            token: result.data.AccessToken,
            refreshToken: result.data.RefreshToken,
            expired: expired
        };
    }
    return new Result<ICertificate>({
        data: data,
        isSuccess: result.isSuccess,
        message: result.message
    })
}

const forgotPassword = function (email: String): Promise<Result<boolean>> {
    return new Promise((resolve, reject) => {
        resolve(new Result<boolean>({
            isSuccess: true,
            message: ""
        }));
    });
}

const changePassword = async (oldPassword: String, newPassword: String): Promise<Result<boolean>> => {
    const res = await repository.post("/Api/Customer/ChangePassword", {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmNewPassword: newPassword
    });

    const result = repository.getResult<any>(res);
    return new Result<boolean>({
        data: true,
        isSuccess: result.isSuccess,
        message: result.message
    })
}

const updateInfo = async (req: IProfileForm): Promise<Result<IProfileForm>> => {
    const res = await repository.post("Api/Customer/UpdateCustomerInfo", {
        firstName: req.firstName,
        lastName: req.lastName,
        gender: req.gender,
        birthday: req.birthDate,
        email: req.email,
        phoneNumber: req.phoneNumber,
        avatarUrl: req.avatar,
        companyName: req.company
    });
    const result = repository.getResult<any>(res);
    let data: IProfileForm | undefined;
    if (result.isSuccess) {
        const dataResult = result.data;
        data = {
            firstName: dataResult.FirstName,
            lastName: dataResult.LastName,
            gender: dataResult.Gender,
            birthDate: dataResult.Birthday,
            email: dataResult.Email,
            phoneNumber: dataResult.PhoneNumber,
            avatar: dataResult.AvatarUrl,
            company: dataResult.CompanyName
        }
        return new Result({
            isSuccess: result.isSuccess,
            message: result.message
        })
    }
    return new Result<IProfileForm>({
        data: data,
        isSuccess: result.isSuccess,
        message: result.message
    })
}

const getProfile = async (): Promise<Result<IProfileForm>> => {
    const res = await repository.get("Api/Customer/CustomerInfo");
    const result = repository.getResult<any>(res);
    let data: IProfileForm | undefined;
    if (result.isSuccess) {
        const dataResult = result.data;
        data = {
            firstName: dataResult.FirstName,
            lastName: dataResult.LastName,
            gender: dataResult.Gender,
            birthDate: dataResult.Birthday,
            email: dataResult.Email,
            phoneNumber: dataResult.PhoneNumber,
            avatar: dataResult.AvatarUrl,
            company: dataResult.CompanyName
        }
    }
    return new Result({
        data: data,
        isSuccess: result.isSuccess,
        message: result.message
    })
}

const resfreshToken = async function (): Promise<Result<ICertificate>> {
    const session = sessionService.get() as ICertificate;
    if (session) {
        const res = await repository.post("api/tokenweb/Refresh", {
            AccessToken: session.token,
            RefreshToken: session.refreshToken
        });
        const result = repository.getResult<any>(res);

        let data: ICertificate | undefined;
        if (result.Ok()) {
            data = {
                token: result.data.AccessToken,
                refreshToken: result.data.RefreshToken
            };
        }

        return new Result<ICertificate>({
            isSuccess: result.isSuccess,
            message: result.message,
            statusCode: result.statusCode,
            data: data
        });
    }
    return new Result<ICertificate>({
        isSuccess: false,
        message: 'session does not found'
    });
}

export {
    login,
    forgotPassword,
    changePassword,
    updateInfo,
    getProfile,
    resfreshToken
};

export interface IProfileForm {
    firstName: string;
    lastName: string;
    gender: string;
    birthDate: string;
    email: string;
    phoneNumber: string;
    avatar: string;
    company: string;
}

export interface ICertificate {
    token: string;
    refreshToken: string;
    expired?: Date;
}